const buttonFilled: object = {
  white: {
    background: 'bg-white',
    color: 'text-blue-gray-900',
    shadow: 'shadow-md shadow-blue-gray-500/10',
    hover: 'hover:shadow-lg hover:shadow-blue-gray-500/20',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  black: {
    background: 'bg-gray-900',
    color: 'text-white',
    shadow: 'shadow-md shadow-gray-900/10',
    hover: 'hover:shadow-lg hover:shadow-gray-900/20',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  'blue-gray': {
    background: 'bg-blue-gray-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-blue-gray-500/20',
    hover: 'hover:shadow-lg hover:shadow-blue-gray-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  gray: {
    background: 'bg-gray-900',
    color: 'text-white',
    shadow: 'shadow-md shadow-gray-900/10',
    hover: 'hover:shadow-lg hover:shadow-gray-900/20',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  brown: {
    background: 'bg-brown-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-brown-500/20',
    hover: 'hover:shadow-lg hover:shadow-brown-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  'deep-orange': {
    background: 'bg-deep-orange-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-deep-orange-500/20',
    hover: 'hover:shadow-lg hover:shadow-deep-orange-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  orange: {
    background: 'bg-orange-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-orange-500/20',
    hover: 'hover:shadow-lg hover:shadow-orange-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  amber: {
    background: 'bg-amber-500',
    color: 'text-black',
    shadow: 'shadow-md shadow-amber-500/20',
    hover: 'hover:shadow-lg hover:shadow-amber-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  yellow: {
    background: 'bg-yellow-500',
    color: 'text-black',
    shadow: 'shadow-md shadow-yellow-500/20',
    hover: 'hover:shadow-lg hover:shadow-yellow-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  lime: {
    background: 'bg-lime-500',
    color: 'text-black',
    shadow: 'shadow-md shadow-lime-500/20',
    hover: 'hover:shadow-lg hover:shadow-lime-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  'light-green': {
    background: 'bg-light-green-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-light-green-500/20',
    hover: 'hover:shadow-lg hover:shadow-light-green-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  green: {
    background: 'bg-green-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-green-500/20',
    hover: 'hover:shadow-lg hover:shadow-green-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  teal: {
    background: 'bg-teal-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-teal-500/20',
    hover: 'hover:shadow-lg hover:shadow-teal-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  cyan: {
    background: 'bg-cyan-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-cyan-500/20',
    hover: 'hover:shadow-lg hover:shadow-cyan-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  'light-blue': {
    background: 'bg-light-blue-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-light-blue-500/20',
    hover: 'hover:shadow-lg hover:shadow-light-blue-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  blue: {
    background: 'bg-blue-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-blue-500/20',
    hover: 'hover:shadow-lg hover:shadow-blue-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  indigo: {
    background: 'bg-indigo-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-indigo-500/20',
    hover: 'hover:shadow-lg hover:shadow-indigo-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  'deep-purple': {
    background: 'bg-deep-purple-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-deep-purple-500/20',
    hover: 'hover:shadow-lg hover:shadow-deep-purple-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  purple: {
    background: 'bg-purple-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-purple-500/20',
    hover: 'hover:shadow-lg hover:shadow-purple-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  pink: {
    background: 'bg-pink-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-pink-500/20',
    hover: 'hover:shadow-lg hover:shadow-pink-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
  red: {
    background: 'bg-red-500',
    color: 'text-white',
    shadow: 'shadow-md shadow-red-500/20',
    hover: 'hover:shadow-lg hover:shadow-red-500/40',
    focus: 'focus:opacity-[0.85] focus:shadow-none',
    active: 'active:opacity-[0.85] active:shadow-none',
  },
};

export default buttonFilled;
